import React from "react";
// @ts-ignore
import {Garage} from "@App/types";
import {Text} from "@eo-locale/react";
import {GarageProfileMapProps} from "@App/components/GarageProfile/GaragProfileParts/GarageProfileMap";
import dynamic from 'next/dynamic'

const GarageProfileMap = dynamic<GarageProfileMapProps>(() => import("@App/components/GarageProfile/GaragProfileParts/GarageProfileMap") as any, {ssr:false })



export type GarageProfileMapLocationProps = {
    garage: Garage
};

export const GarageProfileMapLocation = React.memo<GarageProfileMapLocationProps>(({garage}) => {

    return (
        <div id={'garage-location'} className={'col-span-full mb-6 md:mb-8'}>
            <h2 className={'text-3xl leading-9 text-gray-900 font-serif mb-8'}><Text id={'profileBody_location_headline'}/> {garage.name}</h2>
            <div className={'w-full h-[320px] rounded-md'}>
                <GarageProfileMap garage={garage}/>
            </div>
        </div>
    )
})

GarageProfileMapLocation.displayName = 'GarageProfileMapLocation';
